var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M3.5998 1.79986C3.5203 1.79874 3.44136 1.81343 3.36758 1.84308C3.2938 1.87273 3.22665 1.91674 3.17002 1.97257C3.1134 2.0284 3.06844 2.09492 3.03775 2.16827C3.00706 2.24163 2.99126 2.32035 2.99126 2.39986C2.99126 2.47938 3.00706 2.5581 3.03775 2.63146C3.06844 2.70481 3.1134 2.77133 3.17002 2.82716C3.22665 2.88299 3.2938 2.927 3.36758 2.95665C3.44136 2.9863 3.5203 3.00099 3.5998 2.99986H14.3998C14.4793 3.00099 14.5582 2.9863 14.632 2.95665C14.7058 2.927 14.773 2.88299 14.8296 2.82716C14.8862 2.77133 14.9312 2.70481 14.9619 2.63146C14.9925 2.5581 15.0083 2.47938 15.0083 2.39986C15.0083 2.32035 14.9925 2.24163 14.9619 2.16827C14.9312 2.09492 14.8862 2.0284 14.8296 1.97257C14.773 1.91674 14.7058 1.87273 14.632 1.84308C14.5582 1.81343 14.4793 1.79874 14.3998 1.79986H3.5998ZM3.5998 4.19986C2.94397 4.19986 2.3998 4.74403 2.3998 5.39986V8.99987H3.5998V5.39986H14.3998V8.99987H15.5998V5.39986C15.5998 4.74403 15.0556 4.19986 14.3998 4.19986H3.5998ZM7.1998 6.59986L5.3998 8.99987H8.9998L7.1998 6.59986ZM11.9998 6.59986C11.8407 6.59986 11.6881 6.66308 11.5755 6.7756C11.463 6.88812 11.3998 7.04074 11.3998 7.19986C11.3998 7.35899 11.463 7.51161 11.5755 7.62413C11.6881 7.73665 11.8407 7.79987 11.9998 7.79987C12.1589 7.79987 12.3115 7.73665 12.4241 7.62413C12.5366 7.51161 12.5998 7.35899 12.5998 7.19986C12.5998 7.04074 12.5366 6.88812 12.4241 6.7756C12.3115 6.66308 12.1589 6.59986 11.9998 6.59986ZM10.0498 7.19986L9.2998 8.20065L9.35957 8.28033L9.8998 8.99987H11.3998L10.0498 7.19986ZM1.7998 10.1999V14.3999C1.7998 15.3941 2.6056 16.1999 3.5998 16.1999H14.3998C15.394 16.1999 16.1998 15.3941 16.1998 14.3999V10.1999H1.7998ZM7.7998 11.3999H10.1998C10.531 11.3999 10.7998 11.6687 10.7998 11.9999C10.7998 12.3311 10.531 12.5999 10.1998 12.5999H7.7998C7.4686 12.5999 7.1998 12.3311 7.1998 11.9999C7.1998 11.6687 7.4686 11.3999 7.7998 11.3999Z",
          fill: "currentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }